/**
 * Email Pricing — Single source of truth for email credit pricing.
 * Must match backend/pricing.py email pricing constants exactly.
 *
 * Flat rate: $0.001 per email (0.1¢ per email).
 * Prices are ex GST, AUD.
 */

export const EMAIL_PRICING_RATE = 0.01; // $0.01 per email

// Pre-defined email top-up bundles shown on the Wallet page
export const EMAIL_BUNDLE_OPTIONS = [
  { amountCents: 1000,  label: '$10',  emailEstimate: 1000,   pricePerEmail: '$0.01', tag: null },
  { amountCents: 2000,  label: '$20',  emailEstimate: 2000,   pricePerEmail: '$0.01', tag: 'Most Popular' },
  { amountCents: 5000,  label: '$50',  emailEstimate: 5000,   pricePerEmail: '$0.01', tag: null },
];

/**
 * Calculate email estimate and rate for a custom dollar amount.
 * Flat rate: always $0.01/email regardless of volume.
 */
export function calculateCustomEmailAmount(dollarAmount) {
  if (dollarAmount < 10) return { emailEstimate: 0, pricePerEmail: '-' };
  return {
    emailEstimate: Math.floor(dollarAmount / 0.01),
    pricePerEmail: '$0.01',
  };
}
